import { formatCurrency } from "@sellar-io/common";
import { Button } from "@sellar-io/components";
import type { PricingChangeProduct } from "../../stockList/checkoutV2/lib/useValidateCheckout";
import { CheckoutDialog } from "../../stockList/checkoutV2/lib/CheckoutDialog";

export type UnifiedCheckoutPriceChange = {
  supplierId: number;
  supplierName: string;
  currency: "gbp" | "sgd";
  products: PricingChangeProduct[];
};

type UnifiedCheckoutPriceChangeDialogProps = {
  priceChange: UnifiedCheckoutPriceChange | null;
  onDismiss: () => void;
  onBackToMarket: () => void;
  onAccept: (_priceChange: UnifiedCheckoutPriceChange) => void;
};

export const UnifiedCheckoutPriceChangeDialog = ({
  priceChange,
  onDismiss,
  onBackToMarket,
  onAccept,
}: UnifiedCheckoutPriceChangeDialogProps) => (
  <CheckoutDialog
    isOpen={priceChange != null}
    onDismiss={onDismiss}
    title="Your order price has changed"
    description="Review and accept the latest prices before placing this order."
  >
    {priceChange && (
      <div className="flex flex-col gap-5">
        <p className="text-sm text-zinc-700">
          {priceChange.supplierName} has updated the following product pricing:
        </p>
        <div className="flex flex-col divide-y divide-zinc-200 rounded-lg border border-zinc-200">
          {priceChange.products.map((product) => (
            <div
              key={product.id}
              className="flex items-center justify-between gap-4 p-3 text-sm"
            >
              <span className="font-medium">
                {[product.name.trim(), product.description.trim()]
                  .filter(Boolean)
                  .join(" • ")}
              </span>
              <span className="flex shrink-0 items-center gap-2">
                <span className="text-zinc-500 line-through">
                  {formatCurrency(product.oldPrice, priceChange.currency)}
                </span>
                <span className="font-semibold text-zinc-900">
                  {formatCurrency(product.newPrice, priceChange.currency)}
                </span>
              </span>
            </div>
          ))}
        </div>
        <div className="flex justify-end gap-3">
          <Button color="transparent" onClick={onBackToMarket}>
            Back to market
          </Button>
          <Button onClick={() => onAccept(priceChange)}>
            Accept new price and pay
          </Button>
        </div>
      </div>
    )}
  </CheckoutDialog>
);
